<template>
  <div id="sidebar">
    <b-nav class="for-authors-sidebar" vertical>
      <b-nav-item v-for="item in anchorsList" :key="item.anchor" :to="{ path: '#' + item.anchor}">{{item.name}}</b-nav-item>
    </b-nav>
  </div>
</template>

<script>
  export default {
    name: 'for-authors-page-side-menu',
    props: ['anchorsList'],
    methods: {
      handleScroll () {
        if (!this.$store.state.isEnhanced) {
          let articleAnchors = document.getElementById('sidebar')
          let articleAnchorsParent = articleAnchors.parentElement
          let scrollPosition = articleAnchors ? (parseInt(articleAnchorsParent.offsetTop)) : 0

          // 135 -> Heder.height - #navWrapper.height
          // 60 -> #navWrapper.height + 10
          // 420 -> footer.height + 10
          this.scrolled = window.scrollY > (scrollPosition + 135)

          articleAnchors.style.width = (articleAnchorsParent.offsetWidth - 30) + 'px'
          if (this.scrolled && (window.scrollY + articleAnchors.offsetHeight + 10 + 420) > (document.documentElement.scrollHeight || document.body.scrollHeight)) {
            articleAnchors.style.top = 'auto'
            articleAnchors.style.bottom = 20 + 'px'
            articleAnchors.style.position = 'absolute'
          } else if (this.scrolled) {
            articleAnchors.style.bottom = 'auto'
            articleAnchors.style.top = 60 + 'px'
            articleAnchors.style.position = 'fixed'
          } else {
            articleAnchors.style.position = 'static'
          }
        }
      }
    },
    mounted () {
      window.addEventListener('scroll', this.handleScroll)
    },
    destroyed () {
      window.removeEventListener('scroll', this.handleScroll)
    }
  }
</script>

<style lang="scss">
  .for-authors-sidebar {
    margin-bottom: 20px;
    .nav-item {
      a {
        font-family: 'Merriweather';
        font-style: italic;
        font-size: 14px;
        text-decoration: underline;
        color: $primary-color;
        line-height: 18px;
        padding-right: 0;
        &.active {
           border-left: 3px solid $primary-color;
           text-decoration: none;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// ForAuthorsPageSideMenu.vue?a50d0c3c